import React from 'react';

const Landing: React.FC = () => {
  const scrollToAbout = () => {
    document.getElementById('about')?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section id="hero" className="relative flex flex-col items-center justify-center min-h-screen bg-black text-center px-6 overflow-hidden">
      {/* Subtle background accent */}
      <div className="absolute inset-0 pointer-events-none">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-96 h-96 bg-red-700/10 rounded-full blur-3xl" />
      </div>

      <div className="relative max-w-3xl">
        <p className="text-red-500 font-mono text-xs uppercase tracking-widest mb-6">
          Audio Engineer &amp; .NET Developer
        </p>
        <h1 className="text-7xl md:text-9xl font-black text-white mb-6 leading-none tracking-tight">
          Kim<br />
          <span className="text-red-500">Vallén</span>
        </h1>
        <p className="text-gray-500 text-lg max-w-md mx-auto mb-10 leading-relaxed">
          Crafting exceptional sounds and elegant code since 2004 and 2016.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={scrollToAbout}
            className="bg-red-600 hover:bg-red-700 active:bg-red-800 text-white font-mono text-xs uppercase tracking-widest px-8 py-3.5 transition-colors duration-200"
          >
            Discover My Work
          </button>
          <button
            onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
            className="border border-neutral-700 hover:border-red-500 text-gray-400 hover:text-red-500 font-mono text-xs uppercase tracking-widest px-8 py-3.5 transition-colors duration-200"
          >
            Get in Touch
          </button>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-8 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-gray-600 font-mono text-xs uppercase tracking-widest">Scroll</span>
        <svg className="w-4 h-4 text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
        </svg>
      </div>
    </section>
  );
};

export default Landing;
